import { ITreeNode } from '@blueprintjs/core'
import { some } from 'lodash'
import { LocationNodeType } from '../../components/LocationGroupTrees/components'
import { LocationTreeNodeT } from './forEachNode'

const selectEachParentByFloor = (parent: ITreeNode, isSavedTreeNodeList?: boolean) => {
  const nodeType = (parent as LocationTreeNodeT).nodeData?.nodeType
  if (nodeType !== LocationNodeType.Floor) {
    parent.isSelected = some(parent.childNodes, { isSelected: true })
    if (isSavedTreeNodeList) {
      parent.isExpanded = some(parent.childNodes, { isSelected: true })
    }
  }
}

export default selectEachParentByFloor
